/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Button, FlexRow, FlexCol } from 'sarsaparilla';
import { withCompatRouter, COMPAT_ROUTER_PROP_TYPES } from 'sarsaparilla/legacy';

import { equipmentTypes, NoQuotaMods } from '../../utils/utilsNew';
import PereMarquetteInfoModal from './PereMarquetteInfoModal';
import * as types from '../../constants';

const propTypes = {
    router: COMPAT_ROUTER_PROP_TYPES,
    watercrafts: PropTypes.arrayOf(
        PropTypes.shape({
            qty: PropTypes.number,
            type: PropTypes.number,
        })
    ),
    permitId: PropTypes.string,
    issuanceId: PropTypes.string,
    issuanceStartDate: PropTypes.string,
    isQuotaModifyAllowed: PropTypes.bool,
    hasWatercraftQuota: PropTypes.bool,
};

export class FixedWatercraftList extends React.Component {
    static propTypes = propTypes;

    constructor() {
        super();

        this.state = {
            modalOpen: false,
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onChangeDetailsClick = this.onChangeDetailsClick.bind(this);
    }

    onChangeDetailsClick() {
        const reservationId = `${this.props.issuanceId}${types.RES_ID_DELIMITER}${this.props.permitId}`;
        let url = `/permits/${this.props.permitId}/registration/detailed-availability`;

        const query = {};
        if (reservationId) {
            query.reservationId = reservationId;
        }
        if (this.props.issuanceStartDate) {
            query.date = this.props.issuanceStartDate;
        }

        const queryString = Object.keys(query)
            .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`)
            .join('&');
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        this.props.router.navigate(url);
    }

    openModal() {
        this.setState({
            modalOpen: true,
        });
    }

    closeModal() {
        this.setState({
            modalOpen: false,
        });
    }

    renderChangeDetails() {
        if (!this.props.hasWatercraftQuota) {
            // if quota isn't determined by watercraft number, we don't display this button or text here.
            return null;
        }

        if (this.props.isQuotaModifyAllowed) {
            return (
                <div className="rec-form-item-wrap">
                    <Button
                        type="button"
                        appearance="link"
                        onClick={this.onChangeDetailsClick}
                        className="change-details-link"
                        iconBeforeElement={<Icon iconName="edit" />}
                        screenReaderTextAfter="on Detailed Availability Page"
                    >
                        Modify watercraft count
                    </Button>
                </div>
            );
        }
        return NoQuotaMods;
    }

    renderItem(craft) {
        if (craft.qty === 0) {
            return null;
        }
        return (
            <FlexRow key={craft.type}>
                <FlexCol md={3}>
                    <div className="per-static-form-item">
                        <span id="watercraft-type">{equipmentTypes.get(craft.type)}</span>
                    </div>
                </FlexCol>
                <FlexCol md={2}>
                    <div className="per-static-form-item">
                        <span id="watercraft-amount">{craft.qty}</span>
                    </div>
                </FlexCol>
            </FlexRow>
        );
    }

    render() {
        const total = this.props.watercrafts.reduce((sum, type) => sum + type.qty, 0);
        const howWatercraftCalculatorWorksBtn = (
            <Button
                type="button"
                appearance="link"
                screenReaderTextBefore="Click to open modal on"
                onClick={this.openModal}
                className="per-inline-button"
            >
                How the Watercraft Calculator Works
            </Button>
        );

        return (
            <div className="per-equipment-form per-section-group">
                <div className="rec-order-detail-subsection-title">Watercraft</div>
                <p>
                    Please review the amount of watercraft you selected for this trip.
                    Read {howWatercraftCalculatorWorksBtn} for more info.
                </p>
                <div className="per-total-count-wrapper">
                    <span className="per-total-count">
                        Total Watercraft: <b>{`${total}`}</b>
                    </span>
                </div>
                <FlexRow>
                    <FlexCol md={3}>
                        <label htmlFor="watercraft-type">Type</label>
                        <span id="watercraft-type" />
                    </FlexCol>
                    <FlexCol md={2}>
                        <label htmlFor="watercraft-amount">Quantity</label>
                        <span id="watercraft-amount" />
                    </FlexCol>
                </FlexRow>
                {this.props.watercrafts.map(this.renderItem)}
                <PereMarquetteInfoModal
                    isOpen={this.state.modalOpen}
                    closeModal={this.closeModal}
                />
                {this.renderChangeDetails()}
            </div>
        );
    }
}

export default withCompatRouter(FixedWatercraftList);
